<template>
  <div class="conversation-item" role="listitem">
    <!-- <img class="conversation-item__user-icon" :src="item.agent.photo" v-if="item.agent?.photo" /> -->
    <user-avatar :src="item.agent?.photo" />
    <div class="conversation-item__content">
      <h2 class="conversation-item__title" v-bind:class="{ 'conversation-item__title--closed': resolved }">
        {{ `${getTitle} [#${item.friendly_id}]` }}
      </h2>
      <p class="conversation-item__timestamp" v-bind:class="{ 'conversation-item__timestamp--closed': resolved }">
        {{ timestamp }}{{ via ? ' via ' : '' }}
        <span v-if="via">
          {{ via }}
        </span>
      </p>
    </div>
    <div class="conversation-item__open-link" @click="openWidgetConversation">
      View ticket
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';

import UserAvatar from 'widget/components/UserAvatar.vue';
import routerMixin from 'widget/mixins/routerMixin';

const VIA_MAP = {
  'widget': 'In-App Chat',
  'email': 'Email',
  'slack': 'Slack',
  'microsoft-teams': 'Microsoft Teams',
};

export default {
  name: "ConversationItem",
  components: { UserAvatar },
  props: {
    item: {
      id: Number,
      friendly_id: String,
      agent: {
        name: String,
        photo: String
      },
      created_at: String,
      status: String,
      initial_message: {
        content: String,
        created_at: String,
        title: String,
        source: {
          type: String,
          channel_id: String,
          team_id: String,
          ts: String,
          thread_ts: String
        }
      },
    },
  },
  computed: {
    resolved() {
      return this.item.status === "closed";
    },
    timestamp() {
      return moment(Number(this.item.created_at) * 1000).fromNow();
    },
    via() {
      return VIA_MAP[this.item.initial_message?.source?.type];
    },
    isSlack() {
      return this.item.initial_message?.source?.type === 'slack';
    },
    isWidget() {
      return this.item.initial_message?.source?.type === 'widget';
    },
    getTitle() {
      return (this.item.initial_message.title || this.item.initial_message.content || '').substr(0, 350);
    },
  },
  mixins: [routerMixin],
  methods: {
    ...mapActions('conversation', ['clearConversations', 'fetchOldConversations']),
    async openInSlack() {
      const link = `slack://channel?team=${this.item.initial_message.source.team_id}&id=${this.item.initial_message.source.channel_id}&message=${this.item.initial_message.source.ts}${this.item.initial_message.source.thread_ts ? `&thread_ts=${this.item.initial_message.source.thread_ts}` : ''}`;
      window.open(link, '_blank', 'noreferrer');
    },
    async openWidgetConversation() {
      this.clearConversations();

      await this.fetchOldConversations({ conversationId: this.item.id });

      return this.replaceRoute('messages', { conversationId: this.item.id });
    }
  }
};
</script>

<style scoped lang="scss">
@import "widget/assets/scss/helpers/variables.scss";

.conversation-item {
  background-color: $color-white;
  display: flex;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 1px 4px 0px $color-shadow;

  .conversation-item__user-icon {
    height: 40px;
    width: 40px;
    background-color: $color-light-gray;
    border-radius: 50%;
    flex-shrink: 0;
    text-align: center;
    display: flex;
    align-items: center;
  }

  .conversation-item__content {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 0 15px;
    justify-content: center;

    // &:hover {
    //   color: $color-light-gray;
    //   cursor: pointer;
    // }

    .conversation-item__title {
      font-weight: 500;
      word-break: break-word;
      font-size: 0.85rem;
      line-height: 1.4;
    }

    .conversation-item__title--closed {
      font-weight: 400;
      color: $color-light-gray;
    }

    .conversation-item__timestamp {
      color: $color-gray;
      font-size: 0.75rem;
      margin-top: 0.5rem;
    }

    .conversation-item__timestamp--closed {
      color: $color-light-gray;
    }
  }

  .conversation-item__open-link {
    min-width: fit-content;
    display: flex;
    align-items: center;
  }

  .conversation-item__open-link {
    min-width: fit-content;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .slack-icon {
    background: url('~widget/assets/images/slack.svg') center center no-repeat;
    background-size: cover;
    height: 17px;
    width: 17px;
    margin-right: 4px;
  }
}
</style>
